export const CONCERTS_STYLES = {
  DEFAULT: "default",
  WISE: "alternate"
};

export const CONCERTS_STYLE_OPTIONS = [
  {
    label: "Jukebox (default)",
    value: CONCERTS_STYLES.DEFAULT,
    description: "Teal branding with stripe header — the standard concerts look."
  },
  {
    label: "Wise",
    value: CONCERTS_STYLES.WISE,
    description: "Neon green on dark olive — Wise brick-wall styling."
  }
];
